import { generatePathResourceDetail } from '../../../app/routing/routes.config.js';
import { toast } from '../../../store/alerts.js';
import { isTruthy } from '@fabric-app/utils/guards';
import copyToClipboard from 'copy-to-clipboard';
import { RESOURCE_COPY_DATA_TYPE } from './constants.js';
import { create } from 'zustand';
import { useWindowEvent } from '@fabric-app/hooks/useWindowEvent';

const useResourceCopyState = create()((set) => ({
  data: null,
  setData: (data) => set(() => ({
    data
  }))
}));
const getDisplayedMarkupTitle = (name, extension) => [
  name,
  extension
].filter(isTruthy).join(".") || "Untitled item";
const copyResourcesToClipboard = (data, options) => {
  if (data.resources.length === 0) {
    return;
  }
  const addResourcesToClipboardData = options?.addResourcesToClipboardData ?? true;
  const itemsWithFullUrl = data.resources.map(({ id, ...rest }) => {
    const path = generatePathResourceDetail(id, {
      view: "home"
    });
    return {
      ...rest,
      id,
      fullUrl: `${window.location.origin}${path}`
    };
  });
  const textToCopy = itemsWithFullUrl.map((item) => item.fullUrl).join("\n");
  copyToClipboard(textToCopy, {
    format: "text/plain",
    onCopy: addResourcesToClipboardData ? (clipboardData) => {
      clipboardData.setData(RESOURCE_COPY_DATA_TYPE, JSON.stringify(data));
      toast({
        id: "resource-copy",
        content: data.resources.length > 1 ? "Selection copied" : "Item copied"
      });
    } : (clipboardData) => {
      if (itemsWithFullUrl.length > 1) {
        const itemsAsLiMarkup = itemsWithFullUrl.map(({ name, extension, fullUrl }) => `<li><a href="${fullUrl}">${getDisplayedMarkupTitle(name, extension)}</a></li>`).join("\n");
        clipboardData.setData("text/html", `<ul>${itemsAsLiMarkup}</ul>`);
      } else {
        const item = itemsWithFullUrl[0];
        clipboardData.setData("text/html", `<a href="${item.fullUrl}">${getDisplayedMarkupTitle(item.name, item.extension)}</a>`);
      }
      toast({
        id: "resource-copy",
        content: data.resources.length > 1 ? "URLs copied" : "URL copied"
      });
    }
  });
  if (addResourcesToClipboardData) {
    useResourceCopyState.getState().setData(data);
  } else {
    useResourceCopyState.getState().setData(null);
  }
};
const getCopiedResourceClipboardData = (clipboardData) => {
  if (!clipboardData) {
    return null;
  }
  try {
    return JSON.parse(clipboardData.getData(RESOURCE_COPY_DATA_TYPE));
  } catch (_e) {
    return null;
  }
};
const useWindowCopyEventAddFabricResourcesToClipboardData = (data) => {
  useWindowEvent("copy", (event) => {
    event.preventDefault();
    event.stopPropagation();
    copyResourcesToClipboard(data);
  }, {
    enabled: data.resources.length > 0
  });
};

export { copyResourcesToClipboard, getCopiedResourceClipboardData, useResourceCopyState, useWindowCopyEventAddFabricResourcesToClipboardData };
//# sourceMappingURL=copyResourceToClipboard.js.map
